import { extractCalcDimTypeKind } from '../../context/useCalcDims';
import { CALCULATED_DIMENSION_TIMESTAMP_TYPE, CalculatedDimensionType, CalculatedDimensionTypeValue } from './types';

export const CALCULATED_DIMENSIONS_GROUP = 'Calculated Dimensions';

export const toCalculatedDimensionTypeValue = (type?: CalculatedDimensionType | string): CalculatedDimensionTypeValue => {
  if (type === 'DATETIME') return CALCULATED_DIMENSION_TIMESTAMP_TYPE;
  const extracted = extractCalcDimTypeKind(type);
  if (!extracted) return 'TYPE_STRING';
  return ('typeName' in extracted ? extracted.typeName : extracted.kind) as CalculatedDimensionTypeValue;
};

export const toCalculatedDimensionType = (value: CalculatedDimensionTypeValue): CalculatedDimensionType =>
  value === CALCULATED_DIMENSION_TIMESTAMP_TYPE ? { typeNameWrapper: { name: value } } : { kindWrapper: { kind: value } };
